"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = _interopRequireDefault(require("baseStyles/enums/fonts"));
var _types = require("./types");
var _styles = _interopRequireDefault(require("./styles"));
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _excluded = ["children", "type", "dataTestId", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TextSpan = _styledComponents["default"].span.withConfig({
  displayName: "Text__TextSpan",
  componentId: "sc-vbdk40-0"
})(["font-family:", ";font-style:", ";width:", ";max-width:", ";font-size:", ";font-weight:", ";line-height:", ";letter-spacing:", ";color:", ";", " ", ";", " ", " ", " ", " ", " ", " opacity:", ";", " ", " ", " ", " ", " ", " :hover{", ";"], _fonts["default"].Family.GRAPHIE, _fonts["default"].Style.NORMAL, function (props) {
  return props.width ? "".concat(props.width, "px") : 'max-content';
}, function (props) {
  return props.maxWidth ? "".concat(props.maxWidth, "px") : 'max-content';
}, function (props) {
  return "".concat(props.fontSize, "px");
}, function (props) {
  return "".concat(props.fontWeight);
}, function (props) {
  return "".concat(props.lineHeight, "px");
}, function (props) {
  return "".concat(props.letterSpacing || 0, "px");
}, function (props) {
  var _props$theme;
  return props.color || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colorPrimary);
}, function (props) {
  return props.fullWidth && "width: 100%;";
}, function (props) {
  return props.transition && "\n      transition : ".concat(typeof props.transition === "string" ? props.transition : "all 0.5s", ";\n    ");
}, function (props) {
  return (props.width || props.fullWidth || (props === null || props === void 0 ? void 0 : props.maxWidth)) && "\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    ";
}, function (props) {
  var _props$theme2, _props$theme3, _props$theme4;
  return props.cta && "\n        text-decoration: underline;\n        cursor: ".concat(props.disabled ? 'default' : 'pointer', ";\n        color: ").concat(props.color ? props.color : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.colorLink, ";\n        ").concat(props.disabled && "\n          color: ".concat((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.colorLinkDisabled, ";\n        "), "\n        transition: color .5s;\n\n        &:hover {\n          color: ").concat((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.colorLinkHover, ";\n        }\n    ");
}, function (props) {
  return props.noUnderline && "\n      text-decoration: none;\n    ";
}, function (props) {
  return props.disabled && "\n      pointer-events: none;\n      cursor: default;\n    ";
}, function (props) {
  return props.center && "\n      text-align: center;\n    ";
}, function (props) {
  return props.emphasis && "\n      font-weight: ".concat(props.fontWeight === _fonts["default"].Weight.W600 ? _fonts["default"].Weight.W700 : _fonts["default"].Weight.W600, ";\n    ");
}, function (props) {
  return props.opacity || 1;
}, function (props) {
  return props.whiteSpace && " \n      white-space: ".concat(props.whiteSpace, ";\n    ");
}, function (props) {
  return props.lines && "\n      display: -webkit-box; \n      -webkit-box-orient: vertical; \n      -webkit-line-clamp: ".concat(props.lines, "; \n      white-space: break-spaces;\n      word-wrap: break-word;\n    ");
}, function (props) {
  return props.inlineMaxWidth && "\n        max-width: ".concat(props.inlineMaxWidth, ";\n        display: inline-block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        vertical-align: bottom;\n    ");
}, function (props) {
  return props.notSelectable && "\n        user-select: none;\n    ";
}, function (props) {
  return props.textAlign && "\n        text-align: ".concat(props.textAlign, ";\n    ");
}, function (props) {
  return props.textDecoration && "\n       text-decoration: ".concat(props.textDecoration, ";\n    ");
}, function (props) {
  return props.hoverColor && "\n      color: ".concat(props.hoverColor, ";\n    ");
});
var Text = function Text(_ref) {
  var children = _ref.children,
    type = _ref.type,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = (0, _styles["default"])();
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  return /*#__PURE__*/_react["default"].createElement(TextSpan, _extends({
    onClick: onClick,
    "data-test-id": dataTestId,
    className: "sui-text"
  }, styles[type] || styles.NORMAL, {
    theme: theme
  }, props, {
    "data-sentry-element": "TextSpan",
    "data-sentry-component": "Text",
    "data-sentry-source-file": "index.tsx"
  }), children);
};
Text[_types.TextStylesTypes.HS1] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.HS1
  }, props));
};
Text[_types.TextStylesTypes.HS2] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.HS2
  }, props));
};
Text[_types.TextStylesTypes.H1] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H1
  }, props));
};
Text[_types.TextStylesTypes.H2] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H2
  }, props));
};
Text[_types.TextStylesTypes.H3] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H3
  }, props));
};
Text[_types.TextStylesTypes.H4] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.H4
  }, props));
};
Text[_types.TextStylesTypes.NORMAL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.NORMAL
  }, props));
};
Text[_types.TextStylesTypes.SMALL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.SMALL
  }, props));
};
Text[_types.TextStylesTypes.CAPTION] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.CAPTION
  }, props));
};
Text[_types.TextStylesTypes.FOOTER] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    type: _types.TextStylesTypes.FOOTER
  }, props));
};
var _default = exports["default"] = Text;